import { BreakPoints } from '@kanda-libs/ks-design-library';
import Desktop from './Desktop';
import Mobile from './Mobile';

const FormPage = (props) => (
  <BreakPoints
    mobile={<Mobile {...props} />}
    desktop={<Desktop {...props} />}
  />
);

export default FormPage;
